import { authLocalStorage } from 'storage';

export const getCurrentPath = () => {
  const { pathname } = window.location;
  return pathname;
};

export const status = authLocalStorage;
